<template>
  <div>
    <v-card
      max-width="428px"
      flat
      class="mx-auto custom-flat-card"
      elevation="0"
      color="background"
    >
      <v-card-text class="px-0">
        <h2
          class="text-capitalize mb-5 text-center font-Bold-24 gray1--text mb-6 login-form-title"
        >
          {{ $t("authPage.disableGaPage.title") }}
        </h2>
        <v-card
          elevation="0"
          class="px-3 py-1 my-8"
          style="border: unset !important;"
          color="gray7"
        >
          <v-tabs
            class="custom-tabs"
            v-model="selectedTab"
            @change="changeSelectedTab"
            hide-slider
            centered
          >
            <v-tab
              @change="changeTheTab"
              v-for="item in tabs"
              :key="item.tab"
              :href="item.href"
              class="custom-tab rounded-lg"
            >
              {{ item.text }}
            </v-tab>
          </v-tabs>
        </v-card>

        <v-card
          class="description--text pa-3 mb-8"
          :width="$vuetify.breakpoint.smAndUp ? '500' : 'auto'"
        >
          <p class="">
            {{ $t("authPage.disableGaPage.description") }}
          </p>
        </v-card>

        <v-tabs-items v-model="selectedTab">
          <v-tab-item value="mobile">
            <v-card color="background" flat>
              <form ref="form">
                <v-text-field
                  v-model="model.mobile"
                  :rules="[
                    () =>
                      !!model.mobile ||
                      $t('authPage.loginPage.mobile.validation')
                  ]"
                  :label="$t('authPage.loginPage.mobile.label')"
                  name="mobile"
                  type="mobile"
                  filled
                  color="primaryX"
                  id="mobile"
                  background-color="var(--v-field-base)"
                  class="custom-form-control login-form-control custom-hover"
                  autofocus
                >
                </v-text-field>

                <v-text-field
                  autocomplete="on"
                  v-model="password"
                  @change="setPassword"
                  :rules="state.passwordValidation"
                  :label="$t('authPage.loginPage.password.label')"
                  name="password"
                  :type="show1 ? 'text' : 'password'"
                  color="primaryX"
                  filled
                  id="password"
                  background-color="var(--v-field-base)"
                  class="custom-form-control login-form-control custom-hover password-form-control"
                  :class="{ 'rtl-mode': $vuetify.rtl }"
                >
                  <template v-slot:append>
                    <div
                      @click="show1 = !show1"
                      class="show-password-append"
                      style="cursor: pointer"
                    >
                      <v-icon size="24" v-show="show1" clr="var(--v-gray3-base)"
                      >$eyeShow</v-icon
                      >
                      <v-icon
                        size="24"
                        clr="var(--v-gray3-base)"
                        v-show="!show1"
                      >$eyeHidden</v-icon
                      >
                    </div>
                  </template>
                </v-text-field>

                <Captcha
                  @changed="captchaChanged"
                  :captcha-hash="captcha_hash"
                  :reloadCaptcha="reloadCaptcha"
                  captcha-type="users_sign_in"
                  class="mb-3"
                />

                <v-btn
                  @click="$emit('submitHandler')"
                  :loading="loading"
                  block
                  depressed
                  height="50"
                  color="primary"
                  class="auth-submit-btn mb-8"
                ><span class="font-Medium-14">
                    {{ $t("authPage.disableGaPage.loginButton") }}</span
                ></v-btn
                >
              </form>
            </v-card>
          </v-tab-item>

          <v-tab-item value="email">
            <v-card color="background" flat>
              <form ref="form">
                <v-text-field
                  v-model="model.email"
                  :rules="[
                    () =>
                      !!model.email || $t('authPage.loginPage.email.validation')
                  ]"
                  :label="$t('authPage.loginPage.email.label')"
                  name="email"
                  type="text"
                  filled
                  color="primaryX"
                  id="username"
                  background-color="var(--v-field-base)"
                  class="custom-form-control login-form-control custom-hover"
                  autofocus
                >
                </v-text-field>

                <v-text-field
                  autocomplete="on"
                  v-model="password"
                  @change="setPassword"
                  :rules="state.passwordValidation"
                  :label="$t('authPage.loginPage.password.label')"
                  name="password"
                  :type="show1 ? 'text' : 'password'"
                  color="primaryX"
                  filled
                  id="password"
                  background-color="var(--v-field-base)"
                  class="custom-form-control login-form-control custom-hover password-form-control"
                  :class="{ 'rtl-mode': $vuetify.rtl }"
                >
                  <template v-slot:append>
                    <div
                      @click="show1 = !show1"
                      class="show-password-append"
                      style="cursor: pointer"
                    >
                      <v-icon size="24" v-show="show1" clr="var(--v-gray3-base)"
                      >$eyeShow</v-icon
                      >
                      <v-icon
                        size="24"
                        clr="var(--v-gray3-base)"
                        v-show="!show1"
                      >$eyeHidden</v-icon
                      >
                    </div>
                  </template>
                </v-text-field>

                <Captcha
                  @changed="captchaChanged"
                  :captcha-hash="captcha_hash"
                  :reloadCaptcha="reloadCaptcha"
                  captcha-type="users_sign_in"
                  class="mb-3"
                />

                <v-row class="mx-0">
                  <v-col class="pa-3 pa-sm-0">
                    <v-btn
                      @click="$emit('submitHandler')"
                      :loading="loading"
                      block
                      depressed
                      height="50"
                      color="primary"
                      class="auth-submit-btn mb-8"
                    ><span class="font-Medium-14">
                        {{ $t("authPage.disableGaPage.loginButton") }}</span
                    ></v-btn
                    >
                  </v-col>
                </v-row>
              </form>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
const Captcha = () =>
  import(/* webpackChunkName: "Captcha" */ "@/components/Captcha/index");

export default {
  props: ["model", "state"],
  components: { Captcha },
  data() {
    return {
      loading: false,
      valid: false,
      show1: false,
      selectedTab: "mobile",
      password: "",
      tabs: [
        { tab: 1, href: "#mobile", text: this.$t('authPage.disableGaPage.mobile') },
        { tab: 2, href: "#email", text: this.$t('authPage.disableGaPage.email')}
      ],
      emailOrMobile: "",

      captcha_token: null,
      captcha_value: null,
      captcha_hash: null,
      reloadCaptcha: false
    };
  },
  methods: {
    setPassword(value) {
      this.$emit("setPassword", value);
    },
    changeSelectedTab(value) {
      this.$emit("setDisableBy", value);
    },
    changeTheTab() {
      this.model.email = null;
      this.model.mobile = null;
    },
    captchaChanged(captchaData) {
      this.captcha_token = captchaData.token;
      this.captcha_value = captchaData.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  border: 0 !important;
}
.description--text {
  background-color: #1a8cff29;
  line-height: 1.8;
  color: var(--v-primary-base);
}
.custom-tabs {
  width: 100%;
}
.custom-tab {
  transition: all 0.3s;
  width: 50% !important;
}

.custom-tab.v-tab--active {
  background-color: var(--v-gray10-base) !important;
  color: var(--v-primary-base) !important;
  box-shadow: 8px 13px 100px 32px rgba(0,0,0,0.1);

}

.custom-button {
  padding: 4px 8px;
  background-color: transparent;
  border-radius: 8px;
  transition: background-color 0.5s;
  &:hover {
    background-color: var(--v-lightest-base);
  }
}
.custom-login-background {
  background-color: var(--v-lightest-base);
  border-radius: 8px;
}

.login-slider {
  background-color: var(--v-gray7-base);
  height: calc(100vh - 60px) !important;
  overflow: hidden;
}
</style>
